export enum EWalletTypeEnum {
    CASH = 0,
    MOMO = 1,
    VNPAY = 2,
    OTHER = 3,
    MPOS = 4,
    ZALOPAY = 5,
    PAYON = 7,
    PAYOO = 8,
    POSAPP_CARD = 9,
    MPOS_NEW = 10,
    VNPAY_POS = 11,
    UNI_SERVICE = 12,
    EXIMBANK = 13,
    BIDV = 14,
    VIETQR_ACB = 15,
    BANK_TRANSFER = 16
}
